<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44ZM30.0105 15.8683L32.1318 17.9896L26.1213 24.0001L32.1316 30.0104L30.0103 32.1317L24 26.1214L17.9897 32.1317L15.8684 30.0104L21.8787 24.0001L15.8682 17.9896L17.9895 15.8683L24 21.8788L30.0105 15.8683Z" fill-opacity="0.9"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
